import styled, { keyframes, css } from 'styled-components';
import { useEffect, useRef, useState } from 'react';

const marqueeKeyframes = (x: number) =>
  keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(${x}px);
  }
`;

const MarqueeContainer = styled.div<{
  enableAnimation: boolean;
  xMovement: number;
}>`
  width: 100%;
  height: 100%;
  white-space: nowrap;

  &:hover {
    ${({ enableAnimation, xMovement }) =>
      enableAnimation &&
      css`
        animation: ${marqueeKeyframes(xMovement)} 3s linear forwards;
      `}
  }
`;

interface IMarqueeProps {
  text: string;
}

const Marquee: React.FC<IMarqueeProps> = ({ text }) => {
  const textRef = useRef<any>(null);

  const [xMovement, setXMovement] = useState(0);

  useEffect(() => {
    if (!textRef.current) return;

    const calculateWidth = () => {
      if (!textRef.current) return;

      const containerWidth = textRef.current.clientWidth;
      const textWidth = textRef.current.scrollWidth;

      const diff = textWidth - containerWidth;

      setXMovement(diff > 0 ? diff : 0);
    };

    calculateWidth();
    const resizeObserver = new ResizeObserver(() => {
      calculateWidth();
    });

    resizeObserver.observe(textRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [text]);

  return (
    <MarqueeContainer
      ref={textRef}
      enableAnimation={xMovement > 0}
      xMovement={xMovement}
    >
      {text}
    </MarqueeContainer>
  );
};

export default Marquee;
